$(document).ready(function () {
  let productNavSlider = $(".product-nav-slider");
  let productThumbSlider = $(".product-thumb-slider");

  if (
    productNavSlider.length > 0 &&
    !productNavSlider.hasClass("slick-initialized") &&
    productThumbSlider.length > 0 &&
    !productThumbSlider.hasClass("slick-initialized")
  ) {
    productNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: false,
      infinite: true,
      loop: false,
      speed: 1000,
      asNavFor: ".product-thumb-slider",
    });

    productThumbSlider.slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      asNavFor: ".product-nav-slider",
      arrows: true,
      dots: false,
      infinite: true,
      loop: false,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: true,
      prevArrow:
        '<button type="button" class="prev-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7L7 13" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 13L7 7L1 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });
  }

  
    // add click event on bespock color change
    $('input[name="bespoke-option"]').on('change', function() {
      
        let bespokeOptionValue = $('input[name="bespoke-option"]:checked').val();
        if(bespokeOptionValue === "yes"){
            $(".main-product__customise-wrapper.hex_color_option_wrapper").show();
            $(".color_selection_options_wrapper").hide();
        } else {
            $(".main-product__customise-wrapper.hex_color_option_wrapper").hide();
            $(".color_selection_options_wrapper").show();
        }
    });




  // New js start here 28-04-25
  let productCusNavSlider = $(".js-product-cus-nav-slider");
  let productCusThumbSlider = $(".js-product-cus-thumb-slider");

  if (
    productCusNavSlider.length > 0 &&
    !productCusNavSlider.hasClass("slick-initialized") &&
    productCusThumbSlider.length > 0 &&
    !productCusThumbSlider.hasClass("slick-initialized")
  ) {
    productCusNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: false,
      infinite: true,
      speed: 500,
      asNavFor: ".js-product-cus-thumb-slider", // corrected selector
    });

    productCusThumbSlider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".js-product-cus-nav-slider", // corrected selector
      arrows: true,
      dots: false,
      infinite: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: false,
      prevArrow:
        '<button type="button" class="prev-arrow">' +
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7 1L1 7L7 13" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>",
      nextArrow:
        '<button type="button" class="next-arrow">' +
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 13L7 7L1 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>",
    });
  }
  // New js start here 28-04-25

  $(".main-product__quantity-option")
    .find(".cw-product-bundle__variant-option")
    .first()
    .addClass("active-status");

  $(".cw-product-bundle__variant-select").each(function (
    index,
    currentSelecter
  ) {
    // console.log("currentSelecter ", currentSelecter);

    let minPriceOption = null;
    let minPrice = Infinity;
    let firstSelectedQty;

    $(this)
      .find(".cw-product-bundle__variant-option")
      .each(function (i, optiondata) {
        // console.log("optiondata ", optiondata);
        let optionQty = $(optiondata).attr("data-selected-qty");
        if (optionQty && i == 0) {
          firstSelectedQty = optionQty;
          // console.log("firstSelectedQty ", firstSelectedQty);

          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentQty", optionQty);
        }
        const price = parseFloat($(this).data("variant-price") / 100) || 0;

        // Check if price is 59 or above and is the lowest found so far
        if (price >= 59 && price < minPrice) {
          // console.log("price", price);
          minPrice = price;
          minPriceOption = $(this);
        }

        if (
          $(optiondata).attr("data-text").toUpperCase().indexOf("CUSTOM") > -1
        ) {
          $(optiondata).find(".cw-product-bundle__option-price").hide();
        }
      });

    if (minPriceOption) {
      // console.log("check minprice");
      const selectedText = minPriceOption.data("text") || "";
      const selectedSavePercentage =
        minPriceOption.data("save-percentage") || "";
      const selectedPrice = minPriceOption.data("price") || "";
      const selectedVariantPrice = minPriceOption.data("variant-price") || "";
      const selectedValue = minPriceOption.text() || "";

      if (firstSelectedQty) {
        // console.log("optiondata qty ", optionQty);
      }

      // Generate HTML for the selected option display
      const selectedHtml = `
                ${
                  selectedText
                    ? `<span class="cw-product-bundle__variant-text" data-variant-price="${selectedVariantPrice}">${selectedText}</span>`
                    : ""
                }
                ${
                  selectedSavePercentage
                    ? `<span class="cw-product-bundle__variant-save-percentage ssss">${selectedSavePercentage}</span>`
                    : ""
                }
                ${
                  selectedPrice
                    ? `<span class="cw-product-bundle__variant-price demo123">${selectedPrice}</span>`
                    : ""
                }
            `;

      // Update the DOM elements with the selected option's details
      $(this).find(".cw-product-bundle__variant-selected").html(selectedHtml);
      $(this).find('input[type="hidden"]').val(selectedValue);

      // console.log("Selected option:", {
      //     text: selectedText,
      //     savePercentage: selectedSavePercentage,
      //     price: selectedPrice,
      //     variantPrice: selectedVariantPrice
      // });
      OptionsHandler(minPriceOption);
    } else {
      // console.log("No option with a price of 59 or higher found.");
    }
  });

  function OptionsHandler(ele) {
    // console.log("main ele", ele, $(ele).html());
    let selectedText = $(ele).attr("data-text") || "";
    
    let selectedVariantID = Number($(ele).attr("data-variant-id"));

    if ($(".main-product__checkout-button").length > 0) {
      $(".main-product__checkout-button").attr(
        "data-variant-id",
        selectedVariantID
      );
    }

    let selectedSavePercentage = $(ele).attr("data-save-percentage") || "";
    let selectedPrice_02 = $(ele).attr("data-price") || "";
    
    let dataWithoutMoneyPrice = $(ele).attr("data-without-monny-formate") || "";
    let selectedValue = $(ele).text();
    console.log('dataWithoutMoneyPrice ' + dataWithoutMoneyPrice);
    //let qtyDropText = $(".main-product__quantity-option").find(".cw-product-bundle__variant-option").first().data('text');
    let qtyDropText = $(".main-product__quantity-option")
      .find(".cw-product-bundle__variant-option.active-status")
      .data("text");

    // set first option text in qty selector
    $(".main-product__quantity-option")
      .find(
        ".cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
      )
      .text(qtyDropText);

    // set main price
    if ($('.product-vat--price').attr('data-vat-check') === "false") {  }
      $(".main-product__price span").text(selectedPrice_02);
  

    // $(".main-product__price span").text(selectedPrice_02);

    let selectedHtml = "";

    if (selectedText) {
      selectedHtml += `<span class="cw-product-bundle__variant-text">${selectedText}</span>`;
    }
    if (selectedSavePercentage) {
      selectedHtml += `<span class="cw-product-bundle__variant-save-percentage ddddd">${selectedSavePercentage}</span>`;
    }
    if (selectedPrice_02) {
      selectedHtml += `<span class="cw-product-bundle__variant-price" data-without-money-total="${dataWithoutMoneyPrice}" data-total-price="${selectedPrice_02}">${selectedPrice_02}</span>`;
    }

    $(ele)
      .closest(".cw-product-bundle__variant-select")
      .find(".cw-product-bundle__variant-selected")
      .html(selectedHtml);
    $(ele)
      .closest(".cw-product-bundle__variant-select")
      .find('input[type="hidden"]')
      .val(selectedValue);

    $(ele).parent().hide();

    let selected_variant_option_price = parseFloat(
      $(ele).attr("data-variant-price")
    );
    if (
      !isNaN(selected_variant_option_price) &&
      selected_variant_option_price > 0
    ) {
      //   const tenPercent = (selected_variant_option_price * 1 / 100);
      const tenPercent_1 = selected_variant_option_price;

      const fifteenPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="2"]'
      ).attr("data-save-percentage");
      const fifteenPercentFormate = fifteenPercentage.replace("%", "");
      const fifteenPercent =
        (selected_variant_option_price * fifteenPercentFormate) / 100;
      const fifteenPercent_1 = selected_variant_option_price - fifteenPercent;

      const twentyPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="3"]'
      ).attr("data-save-percentage");
      const twentyPercentFormate = twentyPercentage.replace("%", "");
      const twentyPercent =
        (selected_variant_option_price * twentyPercentFormate) / 100;
      const twentyPercent_1 = selected_variant_option_price - twentyPercent;

      const thirtyPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="4"]'
      ).attr("data-save-percentage");
      const thirtyPercentFormate = thirtyPercentage.replace("%", "");
      const thirtyPercent =
        (selected_variant_option_price * thirtyPercentFormate) / 100;
      const thirtyPercent_1 = selected_variant_option_price - thirtyPercent;

      // let percentage_off = $(".main-product__quantity-option")
      //   .find(".cw-product-bundle__variant-save-percentage")
      //   .html();
      let percentage_off = $(".main-product__quantity-option")
        .find(".cw-product-bundle__variant-save-percentage")
        .text()
        .replace("Save", "")
        .trim();

      // if (percentage_off == "20%") {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(twentyPercent_1));
      // } else if (percentage_off == "15%") {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(fifteenPercent_1));
      // } else {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(tenPercent_1));
      // }

      // if (percentage_off == twentyPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(twentyPercent_1));
      // } else if (percentage_off == fifteenPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(fifteenPercent_1));
      // } else if (percentage_off == thirtyPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(thirtyPercent_1));
      // } else {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(tenPercent_1));
      // }

      if (percentage_off == thirtyPercent_1) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(thirtyPercent_1));
      } else if (percentage_off == twentyPercentage) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(twentyPercent_1));
      } else if (percentage_off == fifteenPercentage) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(fifteenPercent_1));
      } else {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(tenPercent_1));
      }

      $('.cw-product-bundle__variant-option[data-selected-qty="4"]').attr(
        "data-price",
        Shopify.formatMoney(thirtyPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="4"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(thirtyPercent_1));

      $('.cw-product-bundle__variant-option[data-selected-qty="3"]').attr(
        "data-price",
        Shopify.formatMoney(twentyPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="3"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(twentyPercent_1));

      $('.cw-product-bundle__variant-option[data-selected-qty="2"]').attr(
        "data-price",
        Shopify.formatMoney(fifteenPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="2"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(fifteenPercent_1));
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]').attr(
        "data-price",
        Shopify.formatMoney(tenPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(tenPercent_1));
      // console.log("data234");

      let UpdatedSizePrice = $(
        ".main-product__select-dropdown.main-product__quantity-option"
      )
        .find(".cw-product-bundle__variant-option.active-status")
        .attr("data-price");
      $(".main-product__select-dropdown.main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .text(UpdatedSizePrice);
    }

    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    if (
      (selected_size_dropdown && selected_size_dropdown.includes("custom")) ||
      (selected_size_dropdown && selected_size_dropdown.includes("Custom")) ||
      (selected_size_dropdown && selected_size_dropdown.includes("CUSTOM"))
    ) {
      $(".custom-width-input-field").show();

      $(".cw-product-bundle__variant-price").hide();
      // custom code
      // console.log("custom option", $(this).html());
      customPriceHandler(this);
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .show()
        .addClass("active-status")
        .trigger("click");
      $(
        '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
      )
        .hide()
        .removeClass("active-status");
      $(".cw-product-bundle__variant-price").hide();
    } else {
      $(".custom-width-input-field").hide();
      $(".cw-product-bundle__variant-price").show();
      $('input[name="width"]').val("");
      $('input[name="length"]').val("");
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .show()
        .addClass("active-status")
        .trigger("click");
      $(
        '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
      )
        .show()
        .removeClass("active-status");
    }

    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    $(`[value="${selected_size_dropdown}"]`).prop("checked", true);
  }

  $(".cw-product-bundle__variant-selected").on("click", function () {
    $(".cw-product-bundle__variant-options")
      .not($(this).siblings(".cw-product-bundle__variant-options"))
      .hide();
    $(this).siblings(".cw-product-bundle__variant-options").toggle();

    // custom code
    // if ($(this).find('.cw-product-bundle__variant-text').text().includes("Custom Size")) {
    //     console.log("custom");
    // } else {
    //     console.log("normal");
    // }
  });

  $(document).on(
    "click",
    ".main-product__size-option .cw-product-bundle__variant-option",
    function () {
      OptionsHandler(this);
   
    }
  );

  $('.main-product__right input[name="color-swatch"]').on(
    "change",
    function () {
      var selectedColorValue = $(
        '.main-product__right input[name="color-swatch"]:checked'
      ).val();
      $(`input[value="${selectedColorValue}"]`).prop("checked", true);
    }
  );

  $(document).on(
    "click",
    ".main-product__quantity-option .cw-product-bundle__variant-option",
    function () {
      $(
        ".main-product__quantity-option .cw-product-bundle__variant-option"
      ).removeClass("active-status");
      $(this).addClass("active-status");
     
      let selectedText = $(this).attr("data-text") || "";
      let selectedSavePercentage = $(this).attr("data-save-percentage") || "";
      let selectedPrice_03 = $(this).attr("data-price") || "";
      let selectedValue = $(this).text();
      let selectedHtml = "";
      let currentClickQty = $(this).attr("data-selected-qty");
      let fourPlusQty = $("#fourplusqty").val();
      let changeQty = $(
        ".main-product__quantity-option .cw-product-bundle__variant-selected"
      );
      if (changeQty) {
        if (selectedText == "4+ Qty") {
          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentqty", fourPlusQty);
        } else {
          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentqty", currentClickQty);
        }
        //$('.main-product__quantity-option .cw-product-bundle__variant-selected').attr('currentqty', currentClickQty);
      }

      if (selectedText) {
        selectedHtml += `<span class="cw-product-bundle__variant-text">${selectedText}</span>`;
      }
      if (selectedSavePercentage) {
        selectedHtml += `<span class="cw-product-bundle__variant-save-percentage qqqqq">Save ${selectedSavePercentage}</span>`;
      }
      if (selectedPrice_03) {
        selectedHtml += `<span class="cw-product-bundle__variant-price">${selectedPrice_03}</span>`;
      }
      $(this)
        .closest(".cw-product-bundle__variant-select")
        .find(".cw-product-bundle__variant-selected")
        .html(selectedHtml);
      $(this)
        .closest(".cw-product-bundle__variant-select")
        .find('input[type="hidden"]')
        .val(selectedValue);

      $(this).parent().hide();
      if (selectedText == "4+ Qty") {
        $(".custom-width-input-field--qty").show();
      } else {
        $(".custom-width-input-field--qty").hide();
      }
      // console.log("data456");
      document.querySelector(".main-product__price span").textContent =
        selectedPrice_03;
    }
  );

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".cw-product-bundle__variant-select").length) {
      $(".cw-product-bundle__variant-options").hide();
    }
  });

  Fancybox.bind("[data-fancybox]", {
    showClass: "checkout-form-popup",
  });

  let trustedLogo = $(".trusted-logo__slider");

  if (trustedLogo.length > 0 && !trustedLogo.hasClass("slick-initialized")) {
    trustedLogo.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  if ($(".ideal-step .ideal-step__block-title").length > 0) {
    $(".ideal-step .ideal-step__block-title").matchHeight({
      byRow: true,
    });
  }

  let formButton = $(".secure-checkout__form .secure-checkout__button");
  let phoneNumberField = document.querySelector(
    ".secure-checkout__fill-data .secure-checkout__field input[type='tel']"
  );
  let iti;

  let phoneNumberInput = document.querySelector("#phone");
  let errorMsg = document.querySelector("#phoneError");
  let validMsg = document.querySelector("#validMsg");

  // Error messages mapped to error codes
  let errorMap = [
    "Invalid number",
    "Invalid country code",
    "Too short",
    "Too long",
    "Invalid number",
  ];

  function reset() {
    if (phoneNumberInput && errorMsg && validMsg) {
      phoneNumberInput.classList.remove("invalid");
      errorMsg.textContent = "";
      errorMsg.style.display = "none";
      validMsg.classList.add("hide");
    } else {
      console.log("Required elements not found");
    }
  }

  let showError = (msg) => {
    phoneNumberInput.classList.add("invalid");
    errorMsg.textContent = msg;
    errorMsg.style.display = "block";
  };

  if ($(phoneNumberField).length > 0) {
    iti = window.intlTelInput(phoneNumberField, {
      initialCountry: "gb",
      separateDialCode: true,
      formatOnDisplay: true,
      nationalMode: false,
      utilsScript:
        "https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.1/build/js/utils.js",
    });

    function resetIntlTelInput() {
      if (typeof intlTelInputUtils !== "undefined") {
        var currentText = telInput.intlTelInput(
          "getNumber",
          intlTelInputUtils.numberFormat.E164
        );
        if (typeof currentText === "string") {
          telInput.intlTelInput("setNumber", currentText); // Auto-format the number
        }
      }
    }
  }

  // Optional: Reset validation when the input is clicked or when the flag is changed
  // phoneNumberInput.addEventListener('focus', reset);

  $(formButton).click(function (e) {
    e.preventDefault();
   
    var isValid = true;

    // Clear previous error messages and invalid class
    $(".error-message").hide();
    $(".secure-checkout__form input").removeClass("invalid");

    // First Name Validation
    let firstName = $("#firstName").val();
    if (firstName && typeof firstName === "string") {
      firstName = firstName.trim();
      let firstNameValid = /^[A-Za-z]+$/.test(firstName);
      if (firstNameValid) {
        $("#firstName").removeClass("invalid");
        $("#firstNameError").hide();
      } else {
        isValid = false;
        $("#firstName").addClass("invalid");
        $("#firstNameError")
          .text("First name must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#firstName").addClass("invalid");
      $("#firstNameError")
        .text("First name is required.")
        .css("display", "block");
    }

    // Surname Validation
    let surname = $("#surname").val();
    if (surname && typeof surname === "string") {
      surname = surname.trim();
      let surnameValid = /^[A-Za-z]+$/.test(surname);
      if (surnameValid) {
        $("#surname").removeClass("invalid");
        $("#surnameError").hide();
      } else {
        isValid = false;
        $("#surname").addClass("invalid");
        $("#surnameError")
          .text("Surname must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#surname").addClass("invalid");
      $("#surnameError").text("Surname is required.").css("display", "block");
    }

    // Company Validation
    let company = $("#company").val();
    if (company && typeof company === "string") {
      company = company.trim();
      let companyValid = /^[A-Za-z\s]+$/.test(company);
      if (companyValid) {
        $("#company").removeClass("invalid");
        $("#companyError").hide();
      } else {
        isValid = false;
        $("#company").addClass("invalid");
        $("#companyError")
          .text("company must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#company").addClass("invalid");
      $("#companyError")
        .text("Company Name is required.")
        .css("display", "block");
    }

    // Email Validation
    let email = $("#email").val();
    if (email && typeof email === "string") {
      email = email.trim();
      let emailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        email
      );
      if (emailValid) {
        $("#email").removeClass("invalid");
        $("#emailError").hide();
      } else {
        isValid = false;
        $("#email").addClass("invalid");
        $("#emailError")
          .text("Please enter a valid email address.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#email").addClass("invalid");
      $("#emailError")
        .text("Email address is required.")
        .css("display", "block");
    }

    reset();

    let phoneNumber = phoneNumberInput.value;
    let validMsg = document.querySelector("#validMsg");
    if (!phoneNumber || phoneNumber.trim() === "") {
      showError("Phone number is required.");
      isValid = false;
    } else if (iti.isValidNumber()) {
      validMsg.classList.remove("hide");

      validMsg.textContent = "✓ Valid";
    } else {
      let errorCode = iti.getValidationError();
      let msg = errorMap[errorCode] || "Invalid number";
      showError(msg);
      isValid = false;
    }

    // If all fields are valid, submit the form
    if (isValid) {
      // Get Number with country code
      // console.log('getNumber ', iti.getNumber() );

      // Remove invalid class and hide error messages for fields that have passed validation
      $(".secure-checkout__field input").each(function () {
        let secureCheckoutInput = $(this);
        if (secureCheckoutInput.val().trim() !== "") {
          secureCheckoutInput.removeClass("invalid");
          secureCheckoutInput.siblings(".error-message").hide();
        }
      });
      // $("form").submit(); // This triggers the form submission

      let backing_value = $('input[name="select-backing"]:checked').val();
      let orientation_value = $(
        'input[name="select-orientation"]:checked'
      ).val();
      let customWidth = $('input[name="width"]:visible').val();
      let customLength = $('input[name="length"]:visible').val();
      let selected_size_value = $(".main-product__size-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
        )
        .html();
      let selected_product_price_value = $(".main-product__size-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .html();
      let selected_product_quantity_value = $(".main-product__quantity-option")
        .find(".cw-product-bundle__variant-selected")
        .attr("currentqty");
      let discount_percentage_value = $(".main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-save-percentage"
        )
        .html();
      let total_price_value = $(".main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .html();
      let selected_color_value = $(".main-product__color-option")
        .find('input[name="color-swatch"]:checked')
        .val();

      let selected_bg_color_value = $(".main-product__color-option")
        .find('input[name="background-color-swatch"]:checked')
        .attr('data-color-name');
      const variantData = JSON.parse($(".data-variant-selector").text());
      const selectedOptions = $(".product-set-variant").find(
        "input[type=radio]:checked"
      );
      // console.log(selectedOptions)
      const selectedOptionValues = [];
      selectedOptions.map((i, elm) => {
        selectedOptionValues.push($(elm).val());
      });
      // console.log(selectedOptionValues)
      // console.log('variantData ',variantData)
      const currentVariant = variantData.find((variant) =>
        variant.options.every(
          (value, index) => value === selectedOptionValues[index]
        )
      );
      // console.log(currentVariant.id)
      // let queryparameters;
      // let currentUrl = window.location.href;
      //       if (currentUrl.includes('utm_source=') || currentUrl.includes('utm_medium=') || currentUrl.includes('utm_campaign=') || currentUrl.includes('utm_id=') || currentUrl.includes('utm_term=') || currentUrl.includes('utm_content=') || currentUrl.includes('affidsm=') || currentUrl.includes('sub1=') || currentUrl.includes('sub2=') || currentUrl.includes('sub3=') || currentUrl.includes('sub4=') || currentUrl.includes('sub5=') || currentUrl.includes('evclid=')) {
      //           queryparameters = currentUrl.split('?')[1];
      //           console.log("queryparameters ", queryparameters);
      //           sessionStorage.setItem('queryparameters', queryparameters);
      //       }

      const imgElement = $(".main-product__upload-preview img");

      let customer_firstname = $("#secure-checkout").find("#firstName").val();
      let customer_surname = $("#secure-checkout").find("#surname").val();
      let customer_email = $("#secure-checkout").find("#email").val();
      let customer_phone = $("#secure-checkout").find("#phone").val();
      let customer_company = $("#secure-checkout").find("#company").val();

      let customerData = {}; // Initialize the customerData object
      let queryparameters; // Declare queryparameters outside the if block to make it accessible globally

      let currentUrl = window.location.href;
      
      // Check if the URL contains a query string
      if (currentUrl.includes("?")) {
        // Extract query string after '?'
        queryparameters = currentUrl.split("?")[1];
        console.log("queryparameters:", queryparameters);
        sessionStorage.setItem("queryparameters", queryparameters);

        // Parse query parameters into individual key-value pairs and add them to customerData
        queryparameters.split("&").forEach((param) => {
          const [key, value] = param.split("=");
          // Directly add each key-value pair to customerData
          customerData[key] = decodeURIComponent(value || ""); // Handle URL encoding
        });

        
      }

      // Now customerData contains all query parameters dynamically
      // console.log("Final customerData:", customerData);
     
      customerData["Firstname"] = customer_firstname;
      customerData["Surname"] = customer_surname;
      customerData["Email"] = customer_email;
      customerData["Phone"] = customer_phone;
      customerData["Company Name"] = customer_company;

      customerData["Backing"] = backing_value;
      customerData["Orientation"] = orientation_value;
      if (customWidth) {
        customerData["Custom Width"] = customWidth;
        customerData["Custom Length"] = customLength;
      } else {
        customerData["Size"] = selected_size_value;
      }
      // if (selected_size_value) {
      //   customerData["Size"] = selected_size_value;
      // }
      customerData["Product Price"] = selected_product_price_value;
      customerData["Quantity"] = selected_product_quantity_value;
      customerData["Discount percentage"] = discount_percentage_value;
      customerData["Total Price"] = total_price_value;
      if (selected_color_value) {
        customerData["Color"] = selected_color_value;
      }
     
      customerData["Product Variant Id"] = currentVariant.id;

      // Try to get URL from hidden input first, fall back to img src
      const uploadedFileUrlInput = $(".main-product__uploaded-file-url");

      if (uploadedFileUrlInput.length > 0 && uploadedFileUrlInput.val()) {
          // Use hidden input value (works for both images and PDFs)
          customerData["Image URL"] = uploadedFileUrlInput.val();
      } else if (imgElement.length > 0) {
          // Fallback to old method (images only)
          const imageUrl = imgElement.attr("src");
          customerData["Image URL"] = imageUrl;
      }

      let bespokeOptionValue = $('input[name="bespoke-option"]:checked').val();
        if(bespokeOptionValue === "yes"){
          customerData["Background Color"] = $('#color-option-input').val();
        } else {
            if(selected_bg_color_value){
              customerData["Background Color"] = selected_bg_color_value;
            }
        }
      customerData["Bespoke color"] = $('input[name="bespoke-option"]:checked').val(); // Add your new field
     

      // url: "https://www.firstmats.co.uk/",
      $.ajax({
        url: "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/postdata.php",
        method: "POST",
        dataType: "JSON",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(customerData),
        success: function (data) {
          // console.log("submittted form data", customerData);
          $(".secure-checkout__form").addClass("form-submit-success");
        },
        error: function (data) {
          // console.log("error ", data);
          if ($(".secure-checkout__form").hasClass("form-submit-success")) {
            $(".secure-checkout__form").removeClass("form-submit-success");
          }
        },
      });

      if(!$('.secure-checkout__form').hasClass('form-submit-success')){
        $('.secure-checkout__form').addClass('form-submit-success');
      }
    }
  });

  /* get JS Work start */

  $(".custom-mats-product__tabs .tab-a").on("click", function () {
    $(".custom-mats-product__tabs .tab").removeClass("tab-active");
    $(
      ".custom-mats-product__tabs .tab[data-id='" +
        $(this).attr("data-id") +
        "']"
    ).addClass("tab-active");
    $(".custom-mats-product__tabs .tab-a").removeClass("active");
    $(this).parent().find(".tab-a").addClass("active");
  });

  $(".custom-mats-product__video-play").click(function () {
    // Hide the banner
    $(this).parent().hide();

    const videoSrc = $("#youtubeVideo").attr("src") + "&autoplay=1";
    $("#youtubeVideo").attr("src", videoSrc);

    // Show the video container
    $("#videoContainer").css("display", "block");

    // Get the original src, add autoplay, and set it back
  });

  if (
    $(".js-product-lovedby-slider").length > 0 &&
    !$(".js-product-lovedby-slider").hasClass("slick-initialized")
  ) {
    $(".js-product-lovedby-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:
        '<button type="button" class="prev-arrow"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 15L17 21L23 27" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5" cy="20.5" r="20" transform="rotate(-180 20.5 20.5)" stroke="#7D86BC"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 26L24 20L18 14" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5" cy="20.5" r="20" stroke="#7D86BC"/></svg></button>',
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 2,
            arrows: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            arrows: true,
            prevArrow:
              '<button type="button" class="prev-arrow"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow:
              '<button type="button" class="next-arrow"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          },
        },
      ],
    });
  }

  /* get JS Work start */
});

/*
Phone Number Validation (intl-tel-input)
if (iti) {
    let phoneNumber = iti.getNumber(); // Get formatted phone number

    if (phoneNumber && phoneNumber !== "+" && phoneNumber.length > 1) { // Check if there's a value and it's not just the "+" sign
        let phoneValid = iti.isValidNumber(); // Check if the phone number is valid
        if (phoneValid) {
            // Valid field: Remove error message and invalid class
            phoneNumberField.removeClass("invalid");
            $("#phoneError").hide();
        } else {
            // Invalid field: Show error message and add invalid class
            isValid = false;
            phoneNumberField.addClass("invalid");
            $("#phoneError").text("Please enter a valid phone number.").css('display','block');
        }
    } else {
        // Empty field: Show error message and add invalid class
        isValid = false;
        phoneNumberField.addClass("invalid");
        $("#phoneError").text("Phone number is required.").css('display','block');
    }

} else {
    // If iti is not initialized, show error
    isValid = false;
    phoneNumberField.addClass("invalid");
    $("#phoneError").text("Phone number is required.").css('display','block');
}

*/

/* 
Initialize the intlTelInput instance
iti = window.intlTelInput($(phoneNumberField), {
    initialCountry: "auto",  // Auto-detect the country based on the user's IP
    separateDialCode: true, // Display the dial code together with the flag
    formatOnDisplay: true,   // Format the number when displayed
    nationalMode: false,     // Force international number formatting
    geoIpLookup: function (callback) {
        $.get('https://ipinfo.io', function () {}, "jsonp").always(function (resp) {
            var countryCode = (resp && resp.country) ? resp.country : "";
            callback(countryCode);
        });
    },
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.0.3/js/utils.js", // Optional utils script for number formatting and validation
    preferredCountries: [] // Optional: you can list preferred countries here (e.g., ['us', 'gb'])

});
*/

// custom option price handler
function customPriceHandler(selectedOption) { 
  
  const widthInput = document.querySelector('input[name="width"]');
  const lengthInput = document.querySelector('input[name="length"]');
  const mainPriceDisplay = document.querySelector(".main-product__price p span");
  const bundlePriceDisplays = document.querySelectorAll(
    ".cw-product-bundle__variant-price"
  );
  const bundleOptionPriceDisplays = document.querySelectorAll(
    ".cw-product-bundle__variant-option"
  );

  function calculatePrice() {
    const width = parseFloat(widthInput.value) || 0;
    const length = parseFloat(lengthInput.value) || 0;

    if (width > 0 && length > 0) {
      const area = width * length;
      // console.log("area");
      var price;
      if ($('.product-vat--price').attr('data-vat-check') === "false") {
           //var vatPrice = ((area / 10000) * 50.46 + 13) * 1.6 * 1.2;
        price = ((area / 10000) * 50.46 + 13) * 1.6;
           
      }else{
        price = ((area / 10000) * 50.46 + 13) * 1.6 * 1.2;
      }
     
     
      console.log('this is custom price ' + price)
      const formattedPrice = Shopify.formatMoney(price * 100);
 
      // mainPriceDisplay.textContent = formattedPrice;
      $(".main-product__price p span").text(formattedPrice)
      $(".main-product__size-option").find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price").attr('data-without-money-total', formattedPrice)
      bundlePriceDisplays.forEach((element) => {
        element.textContent = formattedPrice;
      });
      bundleOptionPriceDisplays.forEach((ele) => {
        if (ele.getAttribute("data-text").includes("Custom Size")) {
          ele.setAttribute("data-price", formattedPrice);
          ele.setAttribute("data-variant-price", price * 100);
          ele.querySelector(".cw-product-bundle__option-price").textContent =
            formattedPrice;
        }
      });

      quantityPriceHandler(price * 100); // Pass raw price as a number
      $(".cw-product-bundle__variant-price").show();
    } else {
      $(".cw-product-bundle__variant-price").hide();
    }
    $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
      .show()
      .addClass("active-status");
    $(
      '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
    )
      .hide()
      .removeClass("active-status");
  }

  widthInput.addEventListener("input", calculatePrice);
  lengthInput.addEventListener("input", calculatePrice);
}

function quantityPriceHandler(money) {
  
  // console.log("Base money:", money);
  const percentageOffElement = document.querySelector(
    ".main-product__quantity-option .cw-product-bundle__variant-save-percentage"
  );
  const percentageOff = percentageOffElement
    ? percentageOffElement.textContent.replace(/Save\s*/i, "").trim()
    : "";

  const PercentageFifteen = $(
    '.cw-product-bundle__variant-option[data-selected-qty="2"]'
  ).attr("data-save-percentage");
  const PercentageFifteenCleaned = PercentageFifteen.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageFifteenFormate = parseFloat(PercentageFifteenCleaned) / 100;

  const PercentageTwenty = $(
    '.cw-product-bundle__variant-option[data-selected-qty="3"]'
  ).attr("data-save-percentage");
  const PercentageTwentyCleaned = PercentageTwenty.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageTwentyFormate = parseFloat(PercentageTwentyCleaned) / 100;

  const PercentageThirty = $(
    '.cw-product-bundle__variant-option[data-selected-qty="4"]'
  ).attr("data-save-percentage");
  const PercentageThirtyCleaned = PercentageThirty.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageThirtyFormate = parseFloat(PercentageThirtyCleaned) / 100;
  // Calculate 15% and 20% discounts
  const fifteenPercentOff = money - money * PercentageFifteenFormate;
  const twentyPercentOff = money - money * PercentageTwentyFormate;
  const thirtyPercentOff = money - money * PercentageThirtyFormate;

  let price;
  if (percentageOff === PercentageThirty) {
    price = Shopify.formatMoney(thirtyPercentOff);
  } else if (percentageOff === PercentageTwenty) {
    price = Shopify.formatMoney(twentyPercentOff);
  } else if (percentageOff === PercentageFifteen) {
    price = Shopify.formatMoney(fifteenPercentOff);
  } else {
    price = Shopify.formatMoney(money);
  }

  // Update main quantity option price display
  const mainPriceElement = document.querySelector(
    ".main-product__quantity-option .cw-product-bundle__variant-price"
  );
  if (mainPriceElement) {
    mainPriceElement.innerHTML = price;
    // console.log("price changed along with qty!!");
  }

  // Function to update variant options
  const updateVariantOption = (qty, discountPrice) => {
    const variantOption = document.querySelector(
      `.cw-product-bundle__variant-option[data-selected-qty="${qty}"]`
    );
    if (variantOption) {
      variantOption.setAttribute("data-price", discountPrice);
      const optionPriceElement = variantOption.querySelector(
        ".cw-product-bundle__option-price"
      );
      if (optionPriceElement) {
        optionPriceElement.innerHTML = discountPrice;
      }
    }
  };

  // Update each variant option price
  updateVariantOption("4", Shopify.formatMoney(thirtyPercentOff));
  updateVariantOption("3", Shopify.formatMoney(twentyPercentOff));
  updateVariantOption("2", Shopify.formatMoney(fifteenPercentOff));
  updateVariantOption("1", Shopify.formatMoney(money));

  // console.log("20% Discounted Price:", Shopify.formatMoney(twentyPercentOff));
  // console.log("15% Discounted Price:", Shopify.formatMoney(fifteenPercentOff));
  // console.log("Original Price:", Shopify.formatMoney(money));
}

// Listen for events like afterClose, close, clickOutside after Fancybox has been opened
// Fancybox.defaults.afterClose = function() {
//   console.log("afterClose");
//   // Remove class from form after closing
//   const form = document.querySelector('.secure-checkout__form');
//   if (form && form.classList.contains('form-submit-success')) {
//     form.classList.remove('form-submit-success');
//   }
// };

// Fancybox.defaults.on = {
//   close: function() {
//     console.log("close");
//     const form = document.querySelector('.secure-checkout__form');
//     if (form && form.classList.contains('form-submit-success')) {
//       form.classList.remove('form-submit-success');
//     }
//   },
//   clickOutside: function() {
//     console.log("clickOutside");
//     const form = document.querySelector('.secure-checkout__form');
//     if (form && form.classList.contains('form-submit-success')) {
//       form.classList.remove('form-submit-success');
//     }
//   }
// };

$("#fourplusqty").on("input", function () {
  // Get the value of the changed input
  let qtyText =
    $(".main-product__quantity-option .cw-product-bundle__variant-option").attr(
      "data-text"
    ) || "";
  var inputValue = $(this).val();
  if (qtyText == "4+ Qty") {
  }
  $(".main-product__quantity-option .cw-product-bundle__variant-selected").attr(
    "currentqty",
    inputValue
  );
});

// $(document).on("click", ".js-click-step-sigh-up", function(){
//   $(this).parent('.first-screen').hide();
//   $(this).parent('.first-screen').siblings('.second-screen').show();
// })

